import React from 'react';
import ReactDOM from 'react-dom/client';
import './root.css'
import '../src/pages/genarel.css'
import Routess from './pathes';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routess />
  </React.StrictMode>
);

